import {combineEpics, Epic} from 'redux-observable';
import {from, merge, timer} from 'rxjs';
import {catchError, filter, map, mergeMap, switchMap, throttleTime} from 'rxjs/operators';
import {notiDeleteAction, notiMarkReadAction, notiRefreshAction, notiResponseAction} from 'module/Noti/action/NotiAction';
import {deleteNotiAPI, fetchCurrentNoti, markNotiReadAPI, markNotiUnreadAPI} from 'module/Noti/api/NotiAPI';
import {noopAction} from 'util/ReduxUtil';
import {notiDrawerOpenAction} from 'module/Noti/action/NotiDrawerAction';
import {auditDocumentVisible} from 'util/rxjsOperators/auditDocumentVisible';
import {isAnyOf} from 'util/redux';
import {alertServerError} from 'module/ConfirmDialog/component/ConfirmDialogContainer'


const RefreshNotiEpic: Epic = $action => merge(
	timer(7000, 120000),
	$action.pipe(filter(isAnyOf(notiRefreshAction, notiDrawerOpenAction))),
).pipe(
	auditDocumentVisible(),
	throttleTime(8000),
	switchMap(() =>
		from(fetchCurrentNoti()).pipe(
			map(({data}) => notiResponseAction(data)),
			catchError(err => {
				void alertServerError(err)
				return [];
			}),
		),
	),
);

const ReadEpic: Epic = action$ => action$.pipe(
	filter(notiMarkReadAction.match),
	filter(action => !action.payload.onlyLocal),
	mergeMap(({payload: {id, read}}) =>
		from(read ? markNotiReadAPI(id) : markNotiUnreadAPI(id)).pipe(
			map(() => noopAction(['noti read', id, read])),
			catchError((err) => {
				void alertServerError(err)
				return [notiMarkReadAction({id, read: !read, onlyLocal: true})];
			}),
		),
	),
);

const DeleteEpic: Epic = action$ => action$.pipe(
	filter(notiDeleteAction.match),
	mergeMap(({payload: id}) =>
		from(deleteNotiAPI(id)).pipe(
			map(() => noopAction(['noti delete', id])),
			catchError(err => {
				void alertServerError(err)
				return [];
			}),
		),
	),
);

export const NotiEpic = combineEpics(RefreshNotiEpic, ReadEpic, DeleteEpic);